import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = { class: "d-flex mt-6" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  href: "javascript:;",
  class: "btn btn-sm btn-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_offer_a_deal"
}
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = /*#__PURE__*/_createVNode("button", {
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-three-dots fs-3" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("        ")
const _hoisted_8 = {
  key: 2,
  style: {"width":"30px"}
}
const _hoisted_9 = { href: "#/mgpayscan/" }
const _hoisted_10 = { class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary" }
const _hoisted_11 = { class: "svg-icon svg-icon-3tx svg-icon-warning" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("        ")
const _hoisted_13 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_14 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountList = _resolveComponent("AccountList")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.isOverriden)
          ? (_openBlock(), _createBlock("a", {
              key: 0,
              href: "javascript:;",
              class: "btn btn-sm btn-danger me-3",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.releaseOverrideNow()))
            }, "Release Override"))
          : _createCommentVNode("", true),
        _createVNode("a", _hoisted_4, _toDisplayString(_ctx.user.usid), 1)
      ]),
      (_ctx.pt != 'bibo' && _ctx.pt != 'pcp')
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.pt != 'bibo' && _ctx.pt != 'pcp')
              ? (_openBlock(), _createBlock(_component_AccountList, { key: 0 }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowQRCodeScannerIcon === true)
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _hoisted_7
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isShowQRCodeScannerIcon === true)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("a", _hoisted_9, [
              _createVNode("button", _hoisted_10, [
                _createVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/QR-scan.svg" })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowQRCodeScannerIcon === true)
        ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
            _hoisted_12
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        _createVNode("img", { src: _ctx.avatar }, null, 8, ["src"])
      ])
    ]),
    _hoisted_15
  ]))
}